function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.955 -0.905 51.467 74.577",
    fill: "#E74B4B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.767 0C11.095.015.015 10.883 0 24.294c0 10.66 15.48 36.518 22.129 47.144.563.898 1.562 1.445 2.638 1.445 1.077.005 2.078-.545 2.637-1.448 6.65-10.62 22.129-36.47 22.129-47.14C49.518 10.882 38.438.014 24.767 0z",
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(218, 165, 32)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.585718, 0, 0, 1.627525, 5.971385, 3.744949)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMarker);
export default __webpack_public_path__ + "static/media/gold-marker.98bce2f67b445a3de134a175b7469871.svg";
export { ForwardRef as ReactComponent };